import clsx from 'clsx'
import { useRef, useState } from 'react'
import ReactDOM from 'react-dom'

const FloatingText = ({ children, className, enableCopy }) => {
    const containerRef = useRef(null)
    const tooltipHoverRef = useRef(false)
    const [showFull, setShowFull] = useState(false)
    const [position, setPosition] = useState({ top: 0, left: 0, width: 0 })

    const handleMouseEnter = () => {
        const el = containerRef.current
        if (!el) return

        if (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) {
            const rect = el.getBoundingClientRect()
            setPosition({
                top: rect.top + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
            })
            setShowFull(true)
        }
    }

    const handleMouseLeave = () => {
        if (!tooltipHoverRef.current) setShowFull(false)
    }

    return (
        <>
            <div
                ref={containerRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className={clsx(
                    'w-full max-w-full overflow-hidden text-ellipsis truncate whitespace-nowrap',
                    className,
                )}
            >
                {children}
            </div>

            {showFull &&
                ReactDOM.createPortal(
                    <div
                        className={clsx(
                            'absolute z-50 shadow-lg border bg-white border-gray-200 px-2 py-2 rounded',
                            enableCopy ? 'cursor-text select-text' : 'select-none',
                        )}
                        style={{
                            top: position.top - 12,
                            left: position.left - 8,
                            minWidth: position.width,
                            whiteSpace: 'normal',
                        }}
                        onMouseEnter={() => (tooltipHoverRef.current = true)}
                        onMouseLeave={() => {
                            tooltipHoverRef.current = false
                            setShowFull(false)
                        }}
                    >
                        {children}
                    </div>,
                    document.body,
                )}
        </>
    )
}

export default FloatingText
